import { Helper } from '../../Helper';
export class GetInternalObjectPropertyHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.getInternalObject);
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'PICKITEM');
    }
}

//# sourceMappingURL=GetInternalObjectPropertyHelper.js.map
